/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Composite list scope. cutEligible (default) preserves the original behaviour: every composite whose job and paymarket cut mappings are decided, with no narrowing by rowStatus, and only data cuts that returned survey data hydrated. all widens to composites whose cut mappings are still pending and hydrates data cuts without survey data too. cutSelected / needSelection / noData / cutMappingIncomplete narrow the list to composites with that rowStatus.
 */
export enum SurveyReplacementCompositeDataCutRowStatusFilter {
    CUT_ELIGIBLE = 'cutEligible',
    ALL = 'all',
    CUT_SELECTED = 'cutSelected',
    NEED_SELECTION = 'needSelection',
    NO_DATA = 'noData',
    CUT_MAPPING_INCOMPLETE = 'cutMappingIncomplete',
}
